import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const NAV = [
  { label: 'About', href: '#about' },
  { label: 'Projects', href: '#projects' },
  { label: 'Skills', href: '#skills' },
  { label: 'Experience', href: '#experience' },
  { label: 'Certs', href: '#certifications' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState('');

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => {
    const fn = () => { if (window.innerWidth > 768) setOpen(false); };
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, []);

  return (
    <>
      <motion.header
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 200,
          padding: scrolled ? '0.5rem 0' : '0.9rem 0',
          transition: 'padding 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            margin: '0 auto',
            padding: '0.6rem 1.25rem',
            maxWidth: 1200,
            marginLeft: 'clamp(0.75rem, 4vw, 2.5rem)',
            marginRight: 'clamp(0.75rem, 4vw, 2.5rem)',
            borderRadius: '14px',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            background: scrolled
              ? 'linear-gradient(135deg, rgba(255,255,255,0.06), rgba(0,245,255,0.04))'
              : 'rgba(255,255,255,0.02)',
            border: '1px solid rgba(255,255,255,0.08)',
            boxShadow: scrolled
              ? '0 10px 40px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.05)'
              : 'none',
            transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
          }}
        >
          {/* LOGO */}
          <a href="#home" style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', textDecoration: 'none', flexShrink: 0 }}>
            <motion.div
              whileHover={{ scale: 1.1, rotate: 5 }}
              style={{
                width: 34,
                height: 34,
                background: 'linear-gradient(135deg, #00f5ff, #00b4d8)',
                borderRadius: '9px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 900,
                color: '#000',
                fontSize: '0.68rem',
                letterSpacing: '0.05em',
                boxShadow: '0 0 18px rgba(0,245,255,0.45)',
                flexShrink: 0,
              }}
            >
              DD
            </motion.div>
            <div style={{
              color: '#fff',
              fontSize: '0.78rem',
              fontWeight: 700,
              letterSpacing: '0.12em',
              whiteSpace: 'nowrap',
            }}>
              DHARSHITH<span style={{ color: '#00f5ff' }}>.</span>DEV
            </div>
          </a>

          {/* DESKTOP NAV */}
          <nav className="hide-mobile" style={{ display: 'flex', gap: '0.25rem', alignItems: 'center' }}>
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setActive(n.href)}
                style={{
                  position: 'relative',
                  fontSize: '0.62rem',
                  padding: '0.5rem 0.9rem',
                  color: active === n.href ? '#00f5ff' : '#94a3b8',
                  textDecoration: 'none',
                  textTransform: 'uppercase',
                  letterSpacing: '0.08em',
                  borderRadius: '8px',
                  background: active === n.href ? 'rgba(0,245,255,0.08)' : 'transparent',
                  transition: 'color 0.2s, background 0.2s',
                }}
                onMouseEnter={e => { e.currentTarget.style.color = '#00f5ff'; e.currentTarget.style.background = 'rgba(0,245,255,0.06)'; }}
                onMouseLeave={e => {
                  if (active !== n.href) {
                    e.currentTarget.style.color = '#94a3b8';
                    e.currentTarget.style.background = 'transparent';
                  }
                }}
              >
                {n.label}
                {active === n.href && (
                  <motion.div
                    layoutId="navUnderline"
                    style={{
                      position: 'absolute',
                      bottom: 4,
                      left: '25%',
                      right: '25%',
                      height: 1.5,
                      background: '#00f5ff',
                      boxShadow: '0 0 8px #00f5ff',
                      borderRadius: 2,
                    }}
                  />
                )}
              </a>
            ))}
            <a
              href="#contact"
              style={{
                marginLeft: '0.5rem',
                fontSize: '0.6rem',
                padding: '0.5rem 1.1rem',
                color: '#00f5ff',
                textDecoration: 'none',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                borderRadius: '8px',
                border: '1px solid rgba(0,245,255,0.35)',
                background: 'rgba(0,245,255,0.06)',
                whiteSpace: 'nowrap',
                transition: 'all 0.2s',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(0,245,255,0.15)'; e.currentTarget.style.boxShadow = '0 0 16px rgba(0,245,255,0.2)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'rgba(0,245,255,0.06)'; e.currentTarget.style.boxShadow = 'none'; }}
            >
              Hire Me
            </a>
          </nav>

          {/* HAMBURGER BUTTON — fixed centering */}
          <button
            onClick={() => setOpen(!open)}
            className="hamburger-btn"
            aria-label="Toggle menu"
            style={{
              display: 'none',
              width: 38,
              height: 38,
              borderRadius: '10px',
              border: '1px solid rgba(0,245,255,0.25)',
              background: open ? 'rgba(0,245,255,0.12)' : 'rgba(0,245,255,0.06)',
              cursor: 'pointer',
              flexShrink: 0,
              position: 'relative',
              transition: 'background 0.2s',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: '5px',
              padding: 0,
            }}
          >
            <motion.span
              animate={open ? { rotate: 45, y: 7 } : { rotate: 0, y: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                display: 'block',
                width: 18,
                height: 2,
                background: '#00f5ff',
                borderRadius: 2,
                boxShadow: '0 0 6px rgba(0,245,255,0.6)',
              }}
            />
            <motion.span
              animate={open ? { opacity: 0, scaleX: 0 } : { opacity: 1, scaleX: 1 }}
              transition={{ duration: 0.2 }}
              style={{
                display: 'block',
                width: 18,
                height: 2,
                background: '#00f5ff',
                borderRadius: 2,
                boxShadow: '0 0 6px rgba(0,245,255,0.6)',
              }}
            />
            <motion.span
              animate={open ? { rotate: -45, y: -7 } : { rotate: 0, y: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                display: 'block',
                width: 18,
                height: 2,
                background: '#00f5ff',
                borderRadius: 2,
                boxShadow: '0 0 6px rgba(0,245,255,0.6)',
              }}
            />
          </button>
        </div>
      </motion.header>

      {/* MOBILE MENU */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -12, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -12, scale: 0.97 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            style={{
              position: 'fixed',
              top: 76,
              left: 'clamp(0.75rem, 4vw, 2.5rem)',
              right: 'clamp(0.75rem, 4vw, 2.5rem)',
              zIndex: 190,
              borderRadius: '18px',
              padding: '0.75rem',
              backdropFilter: 'blur(24px)',
              WebkitBackdropFilter: 'blur(24px)',
              background: 'rgba(5,10,18,0.92)',
              border: '1px solid rgba(0,245,255,0.12)',
              boxShadow: '0 20px 60px rgba(0,0,0,0.6), 0 0 0 1px rgba(0,245,255,0.05)',
            }}
          >
            {/* Top glow line */}
            <div style={{
              position: 'absolute', top: 0, left: '15%', right: '15%', height: 1,
              background: 'linear-gradient(to right, transparent, rgba(0,245,255,0.4), transparent)',
              borderRadius: 1,
            }} />

            {NAV.map((n, i) => (
              <motion.a
  key={n.href}
  href={n.href}
  initial={{ opacity: 0, x: -16 }}
  animate={{ opacity: 1, x: 0 }}
  transition={{ delay: i * 0.06, duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
  onClick={() => { setOpen(false); setActive(n.href); }}
  style={{
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.9rem 1rem 0.9rem 1.2rem', // extra left space for border
    borderRadius: '10px',
    textDecoration: 'none',
    fontSize: '0.9rem',
    fontWeight: 500,
    letterSpacing: '0.04em',
    color: active === n.href ? '#00f5ff' : '#cbd5e1',
    background: active === n.href ? 'rgba(0,245,255,0.08)' : 'transparent',
    borderBottom: i < NAV.length - 1 ? '1px solid rgba(255,255,255,0.04)' : 'none',
    transition: 'background 0.2s, color 0.2s',
  }}
  onMouseEnter={e => {
    e.currentTarget.style.background = 'rgba(0,245,255,0.06)';
    e.currentTarget.style.color = '#00f5ff';
  }}
  onMouseLeave={e => {
    e.currentTarget.style.background = active === n.href ? 'rgba(0,245,255,0.08)' : 'transparent';
    e.currentTarget.style.color = active === n.href ? '#00f5ff' : '#cbd5e1';
  }}
>
  {/* 🔥 LEFT BORDER HIGHLIGHT */}
  {active === n.href && (
    <motion.div
      layoutId="mobileActiveBorder"
      style={{
        position: 'absolute',
        left: 0,
        top: '20%',
        bottom: '20%',
        width: 3,
        borderRadius: 3,
        background: '#00f5ff',
        boxShadow: '0 0 10px #00f5ff',
      }}
    />
  )}

  {/* Label */}
  <span>{n.label}</span>

  {/* Arrow */}
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgba(0,245,255,0.4)" strokeWidth="2">
    <path d="m9 18 6-6-6-6"/>
  </svg>
</motion.a>
            ))}

            <div style={{ padding: '0.75rem 1rem 0.25rem' }}>
              <a
                href="#contact"
                onClick={() => setOpen(false)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem',
                  padding: '0.85rem',
                  borderRadius: '10px',
                  textDecoration: 'none',
                  fontSize: '0.75rem',
                  fontWeight: 700,
                  letterSpacing: '0.12em',
                  textTransform: 'uppercase',
                  color: '#000',
                  background: 'linear-gradient(135deg, #00f5ff, #00b4d8)',
                  boxShadow: '0 0 24px rgba(0,245,255,0.3)',
                }}
              >
                Hire Me
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <style>{`
        @media (max-width: 768px) {
          .hide-mobile { display: none !important; }
          .hamburger-btn { display: inline-flex !important; }
        }
      `}</style>
    </>
  );
}